export default __webpack_public_path__ + "static/media/testing-full-HD.d267342c.jpg";